import { useEffect, useState } from 'react'
import { isNumber } from '../type'

export const useDerivedState = (
  defaultValue: string | number,
  modifier?: (value: string | number) => string | number,
): [string | number, (value: string | number) => void] => {
  const [value, setValue] = useState(
    modifier ? modifier(defaultValue) : defaultValue,
  )
  useEffect(() => {
    if (defaultValue || isNumber(defaultValue)) {
      setValue(modifier ? modifier(defaultValue) : defaultValue)
    }
  }, [defaultValue, modifier])

  return [value, setValue]
}
